/**
 * Central Source of Truth for Lashary FB Market Suite Product Release
 * Update here when new versions (e.g. v1.6, v1.7) are released.
 */

export const CURRENT_VERSION = '1.5';
export const CURRENT_VERSION_FULL = 'v1.5.0';
export const RELEASE_DATE = 'September 2026';
export const DOWNLOAD_FILENAME = 'Lashary_FBMarketSuite_v1.5_x64_Setup.exe';
export const DOWNLOAD_FRIENDLY_NAME = 'Lashary-FB-Market-Suite-1.5.exe';
export const DOWNLOAD_SIZE = '84.2 MB';
export const DOWNLOAD_SHA256 = '01928300F0DFF49EB2308702EF36F720511F95C469C02C15A72CEFFEF5513178';
export const CANONICAL_DOMAIN = 'https://lasharyfbmarketsuite.pages.dev';
export const ADSENSE_CLIENT_ID = 'ca-pub-2908780503721055';
export const ADSENSE_PUBLISHER_ID = 'pub-2908780503721055';

export const ADSENSE_SLOTS = {
  DISPLAY_AUTO: '4576635218',
  IN_ARTICLE: '4970463446',
  MULTIPLEX: '1031218431',
} as const;

export const GOOGLE_DRIVE_DOWNLOAD_URL = 'https://drive.google.com/uc?export=download&id=1cA4ZHUGDdVhjOhcV7fCs1XFS_BbOimXW';
export const GOOGLE_DRIVE_VIEW_URL = 'https://drive.google.com/file/d/1cA4ZHUGDdVhjOhcV7fCs1XFS_BbOimXW/view?usp=sharing';

export const RELEASE_CONFIG = {
  version: CURRENT_VERSION,
  versionFull: CURRENT_VERSION_FULL,
  releaseDate: RELEASE_DATE,
  downloadUrl: GOOGLE_DRIVE_DOWNLOAD_URL,
  directInstallerUrl: GOOGLE_DRIVE_DOWNLOAD_URL,
  googleDriveViewUrl: GOOGLE_DRIVE_VIEW_URL,
  fileName: DOWNLOAD_FILENAME,
  friendlyName: DOWNLOAD_FRIENDLY_NAME,
  fileSize: DOWNLOAD_SIZE,
  checksumSha256: DOWNLOAD_SHA256,
  supportedOS: 'Windows 10 / Windows 11 (64-Bit)',
  minimumRam: '4 GB RAM (8 GB recommended for 3+ parallel accounts)',
  storageReq: '500 MB free SSD storage space',
  browserReq: 'Google Chrome (v115+) or Microsoft Edge',
  displayReq: '1366x768 minimum (1920x1080 Full HD recommended)',
  canonicalDomain: CANONICAL_DOMAIN,
};

export default RELEASE_CONFIG;
